import { render, staticRenderFns } from "./Dashboard-Escola.vue?vue&type=template&id=6e4e9aad&"
import script from "./Dashboard-Escola.vue?vue&type=script&lang=js&"
export * from "./Dashboard-Escola.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Dashboard-Escola.vue"
export default component.exports